import { CircularProgress } from "@material-ui/core";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { categoryListAsync } from "../../hire_ai_Category/redux/categoryApi";
import CustomEditor from "../../CustomEditor/CustomEditor";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";
import { tagListAsync } from "../../Hire_ai_tag/redux/tagApi";
import {
  createBlogAsync,
  getBlogDetailAsync,
  updateBlogAsync,
} from "../redux/blogApi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { HireAiBlogStatus } from "../constants/constants";
import { authorListAsync } from "../../hire_ai_author/redux/authorManagementApi";

const statusOptionList = [
  { status: "Draft", value: HireAiBlogStatus.DRAFT },
  { status: "Published", value: HireAiBlogStatus.PUBLISHED },
  { status: "Pending Review", value: HireAiBlogStatus.PENDING_REVIEW },
  { status: "Future", value: HireAiBlogStatus.FUTURE },
  { status: "Auto Draft", value: HireAiBlogStatus.AUTO_DRAFT },
];

const AddHireAIBlog = () => {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const { selectedBlog } = useSelector((state) => state.blog, shallowEqual);
  const { tags } = useSelector((state) => state.tag, shallowEqual);
  const { categories } = useSelector((state) => state.category, shallowEqual);
  const { authors } = useSelector((state) => state.author, shallowEqual);
  const id = params.id;
  const [file, setFile] = useState({
    file: null,
    url: "",
  });
  const [bannerImage, setBannerImage] = useState({
    file: null,
    url: "",
  });
  const [defaultTag, setDefaultTag] = useState([]);
  const [defaultCategory, setDefaultCategory] = useState([]);
  const [defaultAuthor, setDefaultAuthor] = useState();
  const [createdDate, setCreatedDate] = useState(new Date());
  const [statusOption, setStatusOption] = useState();

  useEffect(() => {
    if (selectedBlog?.faqs?.length) {
    }
  }, [selectedBlog]);

  useEffect(() => {
    dispatch(tagListAsync());
    dispatch(categoryListAsync());
    dispatch(authorListAsync());
    if (id) {
      dispatch(getBlogDetailAsync(id));
    } else {
      // Set to current date and time when creating a new blog
      setCreatedDate(new Date());
    }
  }, []);

  useEffect(() => {
    if (
      selectedBlog &&
      selectedBlog.image &&
      selectedBlog.image !== "undefined" &&
      params?.id !== undefined
    ) {
      setFile({ file: null, url: selectedBlog?.image });
      setBannerImage({ file: null, url: selectedBlog?.bannerImage });
    }
    if (tags.length && selectedBlog?.tag && params?.id !== undefined) {
      let defTagArr = [];
      let tag = [];
      tags.filter((ele) => {
        if (selectedBlog.tag.includes(ele.value)) {
          defTagArr.push({ value: ele.value, label: ele.label });
          tag.push(ele.value);
        }
      });
      setDefaultTag(defTagArr);
    }
    if (
      categories.length &&
      selectedBlog?.category &&
      params?.id !== undefined
    ) {
      let defCategoryArr = [];
      let category = [];
      categories.filter((ele) => {
        if (selectedBlog.category.includes(ele.value)) {
          defCategoryArr.push({ value: ele.value, label: ele.label });
          category.push(ele.value);
        }
      });
      setDefaultCategory(defCategoryArr);
    }
    if (authors && selectedBlog?.author && params?.id !== undefined) {
      // Single-select (not multi) - `defaultAuthor` must be one
      // {value, label} object, matching what changeAuthor()/the Select's
      // own onChange sets it to, not an array (react-select can't read
      // a label off an array and renders blank instead). hireaiblog's
      // `author` field is itself stored as a single-element array (see
      // hireaiblogService.js's create/update), so unwrap that too.
      const authorId = Array.isArray(selectedBlog.author)
        ? selectedBlog.author[0]
        : selectedBlog.author;
      const matchedAuthor = authors.find((ele) => ele.value === authorId);
      setDefaultAuthor(matchedAuthor || null);
    }
    if (selectedBlog && selectedBlog.createdOn && params?.id !== undefined) {
      setCreatedDate(new Date(selectedBlog.createdOn));
    }
    if (selectedBlog && selectedBlog.status && params?.id !== undefined) {
      setStatusOption(selectedBlog.status);
    }
  }, [tags, categories, authors, selectedBlog]);

  const initialValues = {
    slug: "",
    title: "",
    description: "",
    tag: [],
    category: "",
    author: "",
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    createdDate: "",
    status: "",
    blogCTATitel: "",
    blogCTADescription: "",
    blogCTAButton: "",
    faqs: [{ question: "", answer: "" }],
  };
  const redirectBack = () => {
    history.push("/hire_ai_blog");
  };

  const uploadImage = (e) => {
    setFile({
      url: URL.createObjectURL(e.target.files[0]),
      file: e.target.files[0],
    });
  };

  const uploadBannerImage = (e) => {
    setBannerImage({
      url: URL.createObjectURL(e.target.files[0]),
      file: e.target.files[0],
    });
  };

  const addSchema = Yup.object().shape({
    slug: Yup.string()
      .trim()
      .required("Please enter blog slug"),
    title: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter blog Title"
      )
      .required("Please enter blog title"),

    description: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter blog description"
      )
      .required("Please enter blog description"),
    // blogCTATitel: Yup.string()
    //   .trim()
    //   .notOneOf(
    //     ["null", "NULL", "Null", "Undefined", "undefined"],
    //     "Please enter blog BLOG: CTA Title"
    //   )
    //   .required("Please enter blog BLOG: CTA Title"),
    // blogCTADescription: Yup.string()
    //   .trim()
    //   .notOneOf(
    //     ["null", "NULL", "Null", "Undefined", "undefined"],
    //     "Please enter blog BLOG: CTA Description"
    //   )
    //   .required("Please enter BLOG: CTA Description"),
    // blogCTAButton: Yup.string()
    //   .trim()
    //   .notOneOf(
    //     ["null", "NULL", "Null", "Undefined", "undefined"],
    //     "Please enter blog BLOG: CTA Button Name"
    //   )
    //   .required("Please enter BLOG: CTA Button Name"),

    tag: Yup.array(),
    status: Yup.string().required("Please select status"),
    category: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please select category"
      ),
    author: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter blog author name"
      )
      .required("Please enter blog author name"),
    faqs: Yup.array().of(
      Yup.object().shape({
        question: Yup.string().required("Question is required"),
        answer: Yup.string().required("Answer is required"),
      })
    ),
  });

  const changeTag = (e) => {
    let selectedTag = e;
    let tagArr = [];
    if (selectedTag) {
      selectedTag.map((ele) => {
        tagArr.push(ele.value);
      });
    }
    setDefaultTag(e);
    return tagArr;
  };

  const changeCategory = (e) => {
    let selectedCategory = e;
    let categoryArr = [];
    if (selectedCategory) {
      selectedCategory.map((ele) => {
        categoryArr.push(ele.value);
      });
    }
    setDefaultCategory(e);
    return categoryArr;
  };
  const changeAuthor = (e) => {
    let selectedAuthor = e;
    let authorValue = null;
    if (selectedAuthor && selectedAuthor.value) {
      authorValue = selectedAuthor.value;
    }
    setDefaultAuthor(e);
    return authorValue;
  };
  const convertToSlug = (str) => {
    return str
      .toLowerCase()
      .trim()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/-+/g, "-");
  };
  const correctDescription = (description) => {
    if (description != undefined) {
      return description.replaceAll('""', '"');
    }
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={
          selectedBlog && params?.id !== undefined
            ? {
                ...selectedBlog,
                faqs: selectedBlog?.faqs?.length
                  ? selectedBlog.faqs
                  : [{ question: "", answer: "" }],
              }
            : initialValues
        }
        validationSchema={addSchema}
        onSubmit={(values, { setSubmitting, setErrors, resetForm }) => {
          let data = null;
          data = new FormData();
          if (file && file.file) {
            data.append("image", file.file);
          } else if (values && values.image) {
            data.append("image", values.image);
          } else {
            return dispatch(
              showSuccessSnackbar("error", "Please select image", 3000)
            );
          }

          if (bannerImage && bannerImage.file) {
            data.append("bannerImage", bannerImage.file);
          } else if (values && values.bannerImage) {
            data.append("bannerImage", values.bannerImage);
          } else {
            return dispatch(
              showSuccessSnackbar("error", "Please select bannerimage", 3000)
            );
          }

          data.append("slug", values.slug);
          data.append("title", values.title);
          data.append("description", values.description);
          data.append("tag", values.tag);
          data.append("category", values.category);
          data.append("author", values.author);
          data.append("blogCTATitel", values.blogCTATitel);
          data.append("blogCTADescription", values.blogCTADescription);
          data.append("blogCTAButton", values.blogCTAButton);
          data.append("metaTitle", values.metaTitle);
          data.append("metaDescription", values.metaDescription);
          data.append("metaKeywords", values.metaKeywords);
          data.append("createdOn", createdDate.getTime());
          data.append("status", statusOption ? statusOption : "draft");
          data.append("faqs", JSON.stringify(values.faqs));

          setSubmitting(true);
          if (params?.id !== undefined) {
            dispatch(
              updateBlogAsync(data, setSubmitting, resetForm, redirectBack)
            );
            setDefaultTag([]);
            setDefaultCategory([]);
          } else {
            dispatch(
              createBlogAsync(data, setSubmitting, resetForm, redirectBack)
            );
            setDefaultTag([]);
            setDefaultCategory([]);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleBlur,
          handleChange,
          setFieldValue,
          setFieldTouched,
        }) => (
          <Form>
            <Row>
              <Col md={8}>
                <Card>
                  <CardHeader
                    title={
                      <div className="form-group m-0 d-flex align-items-center">
                        <Link className="btn btn-link px-0" to="/hire_ai_blog">
                          <SVG
                            className="h-50 align-self-center"
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Navigation/Arrow-left.svg"
                            )}
                          />
                          Back
                        </Link>
                        <span className="pl-2">
                          {params?.id
                            ? "Edit Hire AI Blog"
                            : "Add Hire AI Blog"}
                        </span>
                      </div>
                    }
                  ></CardHeader>
                  <CardBody>
                    <Row className="justify-content-center">
                      <Col lg={12}>
                        <div className="form-group">
                          <label className="form-label">Slug</label>
                          <input
                            placeholder="Enter Slug"
                            type="text"
                            name="slug"
                            className={
                              errors.slug && touched.slug
                                ? "form-control re_inputRouded is-invalid"
                                : "form-control re_inputRouded"
                            }
                            onChange={handleChange}
                            onBlur={(event) => {
                              let slug = event.target.value;
                              if (slug) {
                                slug = convertToSlug(slug);
                              }
                              setFieldValue("slug", slug);
                            }}
                            value={values.slug ? values.slug : ""}
                          />
                          {touched.slug && errors.slug ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">{errors.slug}</div>
                            </div>
                          ) : null}
                        </div>

                        <div className="form-group">
                          <label className="form-label">Title</label>
                          <input
                            placeholder="Enter Title"
                            type="text"
                            name="title"
                            className={
                              errors.title && touched.title
                                ? "form-control re_inputRouded is-invalid"
                                : "form-control re_inputRouded"
                            }
                            onChange={handleChange}
                            onBlur={(event) => {
                              let title = event.target.value;
                              setFieldValue("title", title);

                              if (!values.slug) {
                                setFieldValue("slug", convertToSlug(title));
                              }
                            }}
                            value={values.title ? values.title : ""}
                          />
                          {touched.title && errors.title ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.title}
                              </div>
                            </div>
                          ) : null}
                        </div>

                        <div className="form-group">
                          <label className="form-label">Description</label>
                          <CustomEditor
                            data={values.description}
                            className={
                              errors.description && touched.description
                                ? "form-control re_inputRouded is-invalid"
                                : "form-control re_inputRouded"
                            }
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setFieldTouched("description", true);
                              setFieldValue("description", data);
                            }}
                          />
                          {touched.description && errors.description ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.description}
                              </div>
                            </div>
                          ) : null}
                        </div>

                        <div className="col-lg-14">
                          <div className="form-group">
                            <label className="form-label">Tag</label>
                            <Select
                              classNamePrefix="react-select"
                              name="tag"
                              isMulti
                              placeholder="Select Tag"
                              className={`form-control border-0 p-0 `}
                              options={tags}
                              onChange={(e) => {
                                let data = changeTag(e);
                                setFieldTouched(
                                  "tag",
                                  data?.length ? true : false
                                );
                                setFieldValue("tag", data);
                              }}
                              value={defaultTag}
                            />
                            {touched.tag && errors.tag ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.tag}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>

                        <div className="col-lg-14">
                          <div className="form-group">
                            <label className="form-label">Category</label>
                            <Select
                              classNamePrefix="react-select"
                              name="category"
                              isMulti
                              placeholder="Select Category"
                              className={`form-control border-0 p-0 `}
                              options={categories}
                              // onChange={(e) => { setFieldValue("category", e.value) }}
                              // value={categories.filter(({ value }) => value === values.category)}
                              onChange={(e) => {
                                let data = changeCategory(e);
                                setFieldTouched(
                                  "category",
                                  data?.length ? true : false
                                );
                                setFieldValue("category", data);
                              }}
                              value={defaultCategory}
                            />
                            {touched.category && errors.category ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {errors.category}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label">BLOG: CTA Title</label>
                          <input
                            placeholder="BLOG: CTA Title"
                            type="text"
                            name="blogCTATitel"
                            className={
                              errors.blogCTATitel && touched.blogCTATitel
                                ? "form-control re_inputRouded is-invalid"
                                : "form-control re_inputRouded"
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={
                              values.blogCTATitel ? values.blogCTATitel : ""
                            }
                          />
                          {touched.blogCTATitel && errors.blogCTATitel ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.blogCTATitel}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className="form-group">
                          <label className="form-label">
                            BLOG: CTA Description
                          </label>
                          <textarea
                            placeholder="BLOG: CTA Description"
                            type="text"
                            name="blogCTADescription"
                            className={
                              errors.blogCTADescription &&
                              touched.blogCTADescription
                                ? "form-control re_inputRouded is-invalid"
                                : "form-control re_inputRouded"
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            rows="7"
                            value={
                              values.blogCTADescription
                                ? values.blogCTADescription
                                : ""
                            }
                          />
                          {touched.blogCTADescription &&
                          errors.blogCTADescription ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.blogCTADescription}
                              </div>
                            </div>
                          ) : null}
                        </div>
                        <div className="form-group">
                          <label className="form-label">BLOG: CTA Button</label>
                          <input
                            placeholder="BLOG: CTA Button"
                            type="text"
                            name="blogCTAButton"
                            className={
                              errors.blogCTAButton && touched.blogCTAButton
                                ? "form-control re_inputRouded is-invalid"
                                : "form-control re_inputRouded"
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={
                              values.blogCTAButton ? values.blogCTAButton : ""
                            }
                          />
                          {touched.blogCTAButton && errors.blogCTAButton ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.blogCTAButton}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Card>
                  <CardHeader
                    title={
                      <div className="form-group m-0 d-flex align-items-center">
                        <span className="pl-2">FAQ's</span>
                      </div>
                    }
                  ></CardHeader>
                  <CardBody>
                    {" "}
                    <div className="form-group">
                      {values?.faqs?.map((faq, index) => (
                        <div key={index} className="faq-section">
                          <div className="form-group">
                            <label>Question</label>
                            <input
                              type="text"
                              name={`faqs[${index}].question`}
                              className={`form-control ${
                                touched.faqs?.[index]?.question &&
                                errors.faqs?.[index]?.question
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={(e) =>
                                setFieldValue(
                                  `faqs[${index}].question`,
                                  e.target.value
                                )
                              }
                              value={faq.question}
                            />
                            {touched.faqs?.[index]?.question &&
                              errors.faqs?.[index]?.question && (
                                <div className="invalid-feedback">
                                  {errors.faqs[index].question}
                                </div>
                              )}
                          </div>

                          <div className="form-group">
                            <label>Answer</label>
                            <textarea
                              name={`faqs[${index}].answer`}
                              className={`form-control ${
                                touched.faqs?.[index]?.answer &&
                                errors.faqs?.[index]?.answer
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={(e) =>
                                setFieldValue(
                                  `faqs[${index}].answer`,
                                  e.target.value
                                )
                              }
                              value={faq.answer}
                            />
                            {touched.faqs?.[index]?.answer &&
                              errors.faqs?.[index]?.answer && (
                                <div className="invalid-feedback">
                                  {errors.faqs[index].answer}
                                </div>
                              )}
                          </div>

                          {/* Remove FAQ button */}
                          <button
                            type="button"
                            className="btn btn-danger mb-4"
                            onClick={() => {
                              const updatedFaqs = values.faqs.filter(
                                (_, i) => i !== index
                              );
                              setFieldValue("faqs", updatedFaqs);
                            }}
                          >
                            Remove FAQ
                          </button>
                        </div>
                      ))}
                      {/* Add FAQ button */}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                          setFieldValue("faqs", [
                            ...values.faqs,
                            { question: "", answer: "" },
                          ]);
                        }}
                      >
                        Add FAQ
                      </button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md={4}>
                <Card>
                  <CardHeader
                    title={
                      <div className="form-group m-0 d-flex align-items-center">
                        <span className="pl-2">Blog Attribute</span>
                      </div>
                    }
                  ></CardHeader>
                  <CardBody>
                    <div className="col-md-12 text-center mb-4">
                      <label className="form-label">Featured Image</label>
                      <div
                        className="pro_img"
                        style={{
                          backgroundImage: `url("${file.url}")`,
                          height: 120,
                          width: "100%",
                          borderRadius: 10,
                          backgroundSize: "contain",
                          border: "1px solid #cccccc",
                        }}
                      >
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          onChange={uploadImage}
                        />
                        <div
                          className="edt_img_btn"
                          style={{ fontSize: 14, paddingTop: 60 }}
                        >
                          <span className="material-icons">edit</span>EDIT
                        </div>
                      </div>
                      <br></br>
                    </div>

                    <div className="col-md-12 text-center mb-4">
                      <label className="form-label">Banner Image</label>
                      <div
                        className="pro_img"
                        style={{
                          backgroundImage: `url("${bannerImage.url}")`,
                          height: 120,
                          width: "100%",
                          borderRadius: 10,
                          backgroundSize: "contain",
                          border: "1px solid #cccccc",
                        }}
                      >
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          onChange={uploadBannerImage}
                        />
                        <div
                          className="edt_img_btn"
                          style={{ fontSize: 14, paddingTop: 60 }}
                        >
                          <span className="material-icons">edit</span>EDIT
                        </div>
                      </div>
                      <br></br>
                    </div>

                    <div className="form-group">
                      <label className="form-label">SEO : Meta Title</label>
                      <input
                        placeholder="Enter meta tile"
                        type="text"
                        name="metaTitle"
                        className={
                          errors.metaTitle && touched.metaTitle
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.metaTitle ? values.metaTitle : ""}
                      />
                      {touched.metaTitle && errors.metaTitle ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {errors.metaTitle}
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        SEO : Meta Description
                      </label>
                      <textarea
                        placeholder="Enter meta Description"
                        type="text"
                        name="metaDescription"
                        className={
                          errors.metaDescription && touched.metaDescription
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        rows="7"
                        value={
                          values.metaDescription ? values.metaDescription : ""
                        }
                      />
                      {touched.metaDescription && errors.metaDescription ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {errors.metaDescription}
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label">SEO : Meta Keywords</label>
                      <input
                        placeholder="Enter meta keywords"
                        type="text"
                        name="metaKeywords"
                        className={
                          errors.metaKeywords && touched.metaKeywords
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.metaKeywords ? values.metaKeywords : ""}
                      />
                      {touched.metaKeywords && errors.metaKeywords ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">
                            {errors.metaKeywords}
                          </div>
                        </div>
                      ) : null}
                    </div>

                    {/* <div className="form-group">
                      <label className="form-label">Author</label>
                      <input
                        placeholder="Enter author name"
                        type="text"
                        name="author"
                        className={
                          errors.author && touched.author
                            ? "form-control re_inputRouded is-invalid"
                            : "form-control re_inputRouded"
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.author ? values.author : ""}
                      />
                      {touched.author && errors.author ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.author}</div>
                        </div>
                      ) : null}
                    </div> */}
                    <div className="form-group">
                      <label className="form-label">Author Name</label>
                      <Select
                        classNamePrefix="react-select"
                        name="author"
                        placeholder="Select Author"
                        className={`form-control border-0 p-0`}
                        options={authors}
                        onChange={(e) => {
                          let data = changeAuthor(e);
                          setFieldTouched(
                            "author",
                            data?.length ? true : false
                          );
                          setFieldValue("author", data);
                        }}
                        value={defaultAuthor}
                      />
                      {touched.author && errors.author ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{errors.author}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Created Date</label>
                      <div>
                        <DatePicker
                          showTimeSelect
                          dateFormat="dd/MM/yyyy h:mm aa"
                          selected={createdDate}
                          onChange={(date) => setCreatedDate(date)}
                          name="createdDate"
                          className={
                            errors.createdDate && touched.createdDate
                              ? "form-control re_inputRouded is-invalid"
                              : "form-control re_inputRouded"
                          }
                        />

                        {touched.createdDate && errors.createdDate ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {errors.createdDate}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="col-lg-14">
                      <div className="form-group">
                        <label className="form-label">Status</label>
                        <select
                          className={
                            errors.status && touched.status
                              ? "form-control re_inputRouded is-invalid"
                              : "form-control re_inputRouded"
                          }
                          name="status"
                          placeholder="Select Status"
                          onChange={(e) => {
                            setStatusOption(e.target.value);
                            setFieldValue("status", e.target.value);
                            setFieldTouched("status", true, false);
                          }}
                          value={statusOption}
                        >
                          {params?.id === undefined ? (
                            <option value="">Select Status</option>
                          ) : null}
                          {statusOptionList.map((listStatus) => (
                            <option
                              value={listStatus.value}
                              key={"status_" + listStatus.value}
                            >
                              {listStatus.status}
                            </option>
                          ))}
                        </select>
                        {touched.status && errors.status ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">{errors.status}</div>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0 mt-4">
                      <div className="mr-5 mb-1 mt-2">
                        <Link
                          className="btn btn-outline-blue"
                          to="/hire_ai_blog"
                        >
                          Close
                        </Link>
                      </div>
                      <div className="mb-1 mt-2">
                        <Button
                          variant="blue"
                          className="px-5 defpddng spinnerBtn"
                          size="lg"
                          type="submit"
                        >
                          {selectedBlog && params?.id !== undefined
                            ? "Update"
                            : "Submit"}
                          {isSubmitting && (
                            <div className="ml-3 basic-verification-loader text-center">
                              <CircularProgress />
                            </div>
                          )}
                        </Button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default AddHireAIBlog;
